var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 31.4,
    height: 31.4,
    rx: 15.7,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 31.4,
    height: 31.4,
    rx: 15.7,
    stroke: "#E5E5E5",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9463 10.9102L21.4815 18.429C21.3627 20.35 21.3034 21.3105 20.8219 22.0011C20.5838 22.3425 20.2773 22.6306 19.9218 22.8472C19.2029 23.2852 18.2405 23.2852 16.3158 23.2852C14.3886 23.2852 13.425 23.2852 12.7056 22.8463C12.3499 22.6294 12.0433 22.3408 11.8053 21.9988C11.3239 21.3071 11.2659 20.3452 11.1497 18.4216L10.6963 10.9102",
    stroke: "#FF4444",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57129 10.9102H23.0713M19.3631 10.9102L18.8511 9.85395C18.511 9.15235 18.3409 8.80155 18.0476 8.58276C17.9825 8.53423 17.9136 8.49106 17.8415 8.45368C17.5167 8.28516 17.1269 8.28516 16.3472 8.28516C15.5479 8.28516 15.1483 8.28516 14.818 8.46075C14.7449 8.49966 14.675 8.54458 14.6093 8.59503C14.3125 8.82268 14.1468 9.18632 13.8152 9.9136L13.361 10.9102",
    stroke: "#FF4444",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4463 19.1602V14.6602",
    stroke: "#FF4444",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1963 19.1602V14.6602",
    stroke: "#FF4444",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.7fe413920f29e9fb1f2197471364acda.svg";
export { ForwardRef as ReactComponent };